import { pushMarkdown } from './aetherTextBlocks.js'

function pushCode(blocks, language, content) {
  blocks.push({
    type: 'code',
    language: language || 'text',
    content: content.replace(/\s+$/, ''),
  })
}

export function buildAetherResponseBlocks(text) {
  if (!text || typeof text !== 'string') return null

  const blocks = []
  const fence = /```([a-zA-Z0-9_-]*)\n([\s\S]*?)```/g
  let cursor = 0
  let match = fence.exec(text)

  while (match) {
    pushMarkdown(blocks, text.slice(cursor, match.index))
    pushCode(blocks, match[1], match[2])
    cursor = match.index + match[0].length
    match = fence.exec(text)
  }

  pushMarkdown(blocks, text.slice(cursor))
  return blocks.length ? blocks : null
}
